/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface SiteGroupModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class SiteGroupApiService extends SignalAdminResourceApiBase<SiteGroupModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'sitegroups');
  }

  listAll(): Observable<SignalAdminResourcePage<SiteGroupModel>> {
    return this.listRelated({});
  }

  listByIds(ids: string[]): Observable<SignalAdminResourcePage<SiteGroupModel>> {
    const selectedIds = ids.slice(0, 1001);
    return this.listRelated({
      id: selectedIds.join(';'),
      pageSize: selectedIds.length
    });
  }

  private listRelated(params: Record<string, any>): Observable<SignalAdminResourcePage<SiteGroupModel>> {
    return this.client.request<SignalAdminResourcePage<SiteGroupModel>>({
      method: 'GET',
      url: this.resourceUri('sitegroups'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 1001,
        ...params
      }
    });
  }
}
